import { endPoint } from "./base.config";

export const internalTransfer = {
  getList: `${endPoint}v2/voucher-payments/:companyId/internal-transfer`,
  getCompanyBank: `${endPoint}company-banks`,
  insertTransaction: `${endPoint}v2/voucher-payments/:companyId/internal-transfer`,
  getStatistic: `${endPoint}v2/voucher-payments/internal-transfer-statistic`,
}